export default "__VITE_ASSET__4710f73b__"